import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { BookDb } from '../redux/bookDbSlice';

const useAllBookDbsInFolder = (folderId: string | undefined) : [string[], BookDb[]] => {
  const bookDb = useSelector((state: RootState) => state.bookDb);
  const relationFolderBookDb = useSelector((state: RootState) => state.relationFolderBookDb);
  const relationFolderBookIds = Object.keys(relationFolderBookDb.relationFolderBooks).filter(id => relationFolderBookDb.relationFolderBooks[id].folderId === folderId);
  relationFolderBookIds.sort((a, b) => {
    const rfbA = relationFolderBookDb.relationFolderBooks[a];
    const rfbB = relationFolderBookDb.relationFolderBooks[b];
    return rfbA.order - rfbB.order;
  })
  const ids = relationFolderBookIds.map(id => relationFolderBookDb.relationFolderBooks[id].bookId);
  const books = ids.map(id => bookDb.books[id]);

  return [ids, books];
}

export default useAllBookDbsInFolder;
